import { render, staticRenderFns } from "./VisitsCard.vue?vue&type=template&id=1cc09c2d&scoped=true"
import script from "./VisitsCard.vue?vue&type=script&lang=ts"
export * from "./VisitsCard.vue?vue&type=script&lang=ts"
import style0 from "./VisitsCard.vue?vue&type=style&index=0&id=1cc09c2d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc09c2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cc09c2d')) {
      api.createRecord('1cc09c2d', component.options)
    } else {
      api.reload('1cc09c2d', component.options)
    }
    module.hot.accept("./VisitsCard.vue?vue&type=template&id=1cc09c2d&scoped=true", function () {
      api.rerender('1cc09c2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/VisitsCard.vue"
export default component.exports